/**
 * Toast — small top-centered notification, shared across app surfaces.
 *
 * Phase 4.3: used by Worksheet Detail for placeholders ("Akan hadir di
 * Phase 4.4") and "✓ Sudah ditandai selesai" confirmations.
 *
 * Pattern matches home.tsx (no native toast dep; uses a View overlay).
 */

import { StyleSheet, Text, View } from 'react-native';

import { Brand, Radii, Spacing } from '@/constants/theme';

interface ToastProps {
  message: string | null;
}

export function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <View pointerEvents="none" style={styles.wrap}>
      <View style={styles.toast}>
        <Text style={styles.text}>{message}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 72,
    alignItems: 'center',
    zIndex: 10,
  },
  toast: {
    backgroundColor: Brand.primary,
    paddingVertical: Spacing.two,
    paddingHorizontal: Spacing.four,
    borderRadius: Radii.medium,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    elevation: 6,
    maxWidth: '90%',
  },
  text: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
  },
});
